import { data } from '../../svg/FeatureSearch/data';
import { makeIcon } from '../makeIcon';

export const FeatureSearch = makeIcon(data, 'feature_search', 'FeatureSearch');

export default FeatureSearch;
